import React, { createContext, useContext, useRef, ReactNode } from 'react';
import { ChatCanvasRef } from '../components/chat/canvas/ChatCanvas';

interface ChatCanvasContextType {
  chatCanvasRef: React.RefObject<ChatCanvasRef | null>;
}

const ChatCanvasContext = createContext<ChatCanvasContextType | undefined>(
  undefined,
);

export const useChatCanvas = () => {
  const context = useContext(ChatCanvasContext);
  if (!context) {
    throw new Error('useChatCanvas must be used within a ChatCanvasProvider');
  }
  return context;
};

interface ChatCanvasProviderProps {
  children: ReactNode;
}

export const ChatCanvasProvider: React.FC<ChatCanvasProviderProps> = ({
  children,
}) => {
  const chatCanvasRef = useRef<ChatCanvasRef>(null);

  return (
    <ChatCanvasContext.Provider value={{ chatCanvasRef }}>
      {children}
    </ChatCanvasContext.Provider>
  );
};
